<template>
    <div class="input-group">
        <label>{{ label }}</label>
        <input :value="value" spellcheck="false" readonly="" @click="selectText(0, value.length, $event)" />
        <button @click="copyText($event, value)">Copy</button>
    </div>
</template>

<script>
export default {
    name: 'IconInputGroup',
    props: {
        label: String,
        value: String,
    },
    methods: {
        selectText(start, end, event) {
            event.target.setSelectionRange(start, end);
        },
        async copyText(event, value) {
            try {
                await navigator.clipboard.writeText(value);
                event.target.innerHTML = 'Copied';
                setTimeout(function() {
                    event.target.innerHTML = 'Copy';
                }, 800);
            } catch (error) {
                console.error(error);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.input-group {
    margin: 2.5rem 0 2rem;
    position: relative;
    label {
        margin: 0;
        position: absolute;
        top: -5px;
        font-style: normal;
        font-weight: 400;
        color: #a1a1a4;
        font-size: 11px;
    }
    input {
        background: #f7f7f7;
        border: none;
        font-family: monospace;
        font-size: 1rem;
        line-height: 2.5rem;
        margin: 0;
        padding: 0 1rem;
        resize: none;
        width: 100%;
    }
    button {
        border-radius: 2px;
        position: absolute;
        bottom: 5px;
        right: 6px;
        background: transparent;
        border: none;
        min-width: 50px;
        padding: 0.5rem;
        cursor: pointer;
        transition: all 0.15s ease-in-out 0s;
        &:hover {
            background: #ddd;
        }
    }
}
</style>
